import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import moduleMeta from './modules/meta';
import moduleRoute from './modules/route';
import modulePosts from './modules/posts';
import moduleMenu from './modules/menu';
import modulePageNavigation from './modules/page-navigation';
import moduleLoader from './modules/loader';
import moduleCoverImage from './modules/cover-image';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    meta: moduleMeta,
    route: moduleRoute,
    posts: modulePosts,
    menu: moduleMenu,
    pageNavigation: modulePageNavigation,
    loader: moduleLoader,
    coverImage: moduleCoverImage,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js